var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogobrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.1 317.4",
    style: {
      enableBackground: "new 0 0 170.1 317.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AF1D41;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "red-nobg"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "148.9,89.7 148.9,155.5 106.7,155.5 106.7,77.7 100.7,77.7 100.7,143.5 82.6,143.5 82.6,53.8  124.8,53.8 124.8,137.5 130.8,137.5 130.8,89.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "154.9,185.4 154.9,263.1 124.8,263.1 124.8,185.4 118.8,185.4 118.8,233.2 106.7,233.2 106.7,161.4  136.9,161.4 136.9,227.2 142.9,227.2 142.9,185.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "76.6,53.8 76.6,179.4 46.4,179.4 46.4,137.5 40.4,137.5 40.4,209.3 22.3,209.3 22.3,89.7 52.4,89.7  52.4,125.6 58.5,125.6 58.5,53.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "100.7,149.5 100.7,251.1 64.5,251.1 64.5,209.3 58.5,209.3 58.5,233.2 46.4,233.2 46.4,185.4  76.6,185.4 76.6,221.2 82.6,221.2 82.6,149.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogobrain);
export default __webpack_public_path__ + "static/media/logobrain.7afc681b6c7d389e349be07bf169edc9.svg";
export { ForwardRef as ReactComponent };